import { useCallback, useEffect, useState } from 'react';
const EMPTY = { mode: 'in-person', visited: [] };
const storageKey = (tourId) => `tour-progress:${tourId}`;
const strings = (x) => Array.isArray(x) ? x.filter((s) => typeof s === 'string') : [];
// Storage can be blocked or hold something an older build wrote, so anything unreadable is a fresh start.
const read = (tourId) => {
    var _a;
    try {
        const raw = JSON.parse((_a = localStorage.getItem(storageKey(tourId))) !== null && _a !== void 0 ? _a : 'null');
        if (typeof raw !== 'object' || raw === null)
            return EMPTY;
        const stored = raw;
        return {
            mode: stored.mode === 'virtual' ? 'virtual' : 'in-person',
            visited: strings(stored.visited),
        };
    }
    catch (_b) {
        return EMPTY;
    }
};
const write = (tourId, progress) => {
    try {
        localStorage.setItem(storageKey(tourId), JSON.stringify(progress));
    }
    catch (_a) {
        // Private windows may refuse; the progress still holds for as long as the page is open.
    }
};
export const useTourProgress = (tourId) => {
    const [progress, setProgress] = useState(() => read(tourId));
    useEffect(() => {
        setProgress(read(tourId));
        // Another tab checking in on the same tour updates this one too.
        const handleStorage = (e) => {
            if (e.key === storageKey(tourId))
                setProgress(read(tourId));
        };
        window.addEventListener('storage', handleStorage);
        return () => window.removeEventListener('storage', handleStorage);
    }, [tourId]);
    const update = useCallback((change) => {
        setProgress(previous => {
            const next = change(previous);
            write(tourId, next);
            return next;
        });
    }, [tourId]);
    const checkIn = useCallback((stopId) => update(p => p.visited.includes(stopId) ? p : Object.assign(Object.assign({}, p), { visited: [...p.visited, stopId] })), [update]);
    const undoCheckIn = useCallback((stopId) => update(p => (Object.assign(Object.assign({}, p), { visited: p.visited.filter(x => x !== stopId) }))), [update]);
    const setMode = useCallback((mode) => update(p => (Object.assign(Object.assign({}, p), { mode }))), [update]);
    return { progress, checkIn, undoCheckIn, setMode };
};
